export const PELATIHAN_MANDIRI_HELPDESK_LINK =
  'https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/sections/46355859184793-Pelatihan-Mandiri'
